<ion-list class="expandable mb0">
    <ion-list-header lines="none" class="mb0 pl0">
        <ion-item style="width: 100%" lines="none" [ngClass]="{'bbn': (expanded)}" [style.background]="headerColor" (click)="toggleAccordion(category)" class="accordion-header pl0" [class.active]="expanded">
            <ion-thumbnail slot="start">
                <img *ngIf="image" src="{{url}}{{image}}">
                <img *ngIf="!image" src="assets/default-img.jpg">
            </ion-thumbnail>
            <ion-icon slot="end" name="ios-arrow-forward"> </ion-icon>
            <ion-label >{{title}}</ion-label>
        </ion-item>
        <!-- <button ion-item detail-none [ngClass]="{'bbn': (expanded)}" [style.background]="headerColor" (click)="toggleAccordion(category)" class="accordion-header"
            [class.active]="expanded">
            <ion-icon slot="end" name="ios-arrow-forward">
            </ion-icon>
            <ion-thumbnail slot="start">
                <img *ngIf="image" src="{{url}}{{image}}">
                <img *ngIf="!image" src="assets/imgs/default-img.jpg">
            </ion-thumbnail>
            <p class="ws">{{title}}</p>
        </button> -->
        <section #accordionContent [style.background]="contentColor" [class.active]="expanded" class="accordion-content">
            <ng-content></ng-content>
        </section>
    </ion-list-header>
</ion-list>